import ModalAlertComponent from "@/components/popup/Modal_Alert";
import http from "@/api/http";

export default {
  install(Vue) {
    /**
     *
     * @param {*} url
     * @param {*} params
     *
     *   // POST 요청 예제.
     *   this.$post("/reqesturl", {"param1":"", "param2":""}, response => {
     *     console.log( response );
     *   }, error => {
     *     console.log( error );
     *   });
     *
     */
    Vue.prototype.$post = function(url, params, cbSuccess, cbError) {
      //공통 헤더 정보를 포함함.

      let postParams;
      let vueObj = this;

      if (url.startsWith("https://")) {
        postParams = params;
      } else {
        let header = {
          browser: this.$store.getters["system/getBrowser"],
          version: this.$store.getters["system/getVersion"],
          os: this.$store.getters["system/getOS"],
          route: this.$route["name"],
          userAgent: navigator.userAgent
        };

        postParams = {
          header: header,
          data: params
        };
      }

      http
        .post(url, postParams, { withCredentials: true })
        .then(response => {
          this.log_debug(response);

          if (!vueObj.$Util.isEmpty(response.data)) {
            if (response.data.code === "000000") {
              if (!vueObj.$Util.isNull(cbSuccess)) {
                cbSuccess(response.data);
              }
            } else {
              //오류 가 났을때 기본 처리
              if (!vueObj.$Util.isNull(cbError)) {
                cbError(response);
              } else {
                //콜백이 등록되지 않았을 경우
                if (
                  !vueObj.$Util.isEmpty(response) &&
                  !vueObj.$Util.isEmpty(response.data)
                ) {
                  if (response.data.code == "900009") {
                    vueObj
                      .$alert({
                        contents: response.data.message,
                        btn_type: vueObj.$CONST.BTN_TP_OK
                      })
                      .then(() => {
                        vueObj.$goBack();
                      });
                  } else if (response.data.code == "900013") {
                    //인증된 사용자가 아닐경우
                    vueObj.toast(response.data.message);
                    setTimeout(() => {
                      vueObj.$goBack();
                    }, 1000);
                  } else {
                    if (
                      response.config.url.indexOf("reqERSLink") == -1 &&
                      response.config.url.indexOf("reqErsSetCbtYn") == -1
                    ) {
                      if (!vueObj.$Util.isEmpty(response.data.message)) {
                        vueObj.toast(response.data.message);
                      } else {
                        vueObj.toast(
                          "일시적으로 서비스 연결이 지연되고 있습니다.<BR />잠시 후 다시 시도해주세요."
                        );
                      }
                    }
                  }
                }
              }
            }
          } else {
            if (!vueObj.$Util.isNull(cbSuccess)) {
              cbSuccess(response.data);
            }
          }
        })
        .catch(error => {
          let initialized = this.$store.getters["system/getInitialized"];
          if (initialized && error.toString().indexOf("Network Error") > -1) {
            this.toast(
              "일시적으로 서비스 연결이 지연되고 있습니다.<BR />잠시 후 다시 시도해주세요."
            );
          } else {
            //오류 가 났을때 기본 처리
            if (!vueObj.$Util.isNull(cbError)) {
              cbError(error.response);
            } else {
              //콜백이 등록되지 않았을 경우
              if (
                !vueObj.$Util.isEmpty(error.response) &&
                !vueObj.$Util.isEmpty(error.response.data)
              ) {
                if (error.response.data.code == "900009") {
                  vueObj
                    .$alert({
                      contents: error.response.data.message,
                      btn_type: vueObj.$CONST.BTN_TP_OK
                    })
                    .then(() => {
                      vueObj.$goBack();
                    });
                } else if (error.response.data.code == "900013") {
                  //인증된 사용자가 아닐경우
                  vueObj.toast(error.response.data.message);
                  setTimeout(() => {
                    vueObj.$goBack();
                  }, 1000);
                } else {
                  if (
                    error.response.config.url.indexOf("reqERSLink") == -1 &&
                    error.response.config.url.indexOf("reqErsSetCbtYn") == -1
                  ) {
                    if (!vueObj.$Util.isEmpty(error.response.data.message)) {
                      vueObj.toast(error.response.data.message);
                    } else {
                      vueObj.toast(
                        "일시적으로 서비스 연결이 지연되고 있습니다.<BR />잠시 후 다시 시도해주세요."
                      );
                    }
                  }
                }
              }
            }
          }
        });
    };

    /**
     *
     * @param {*} url
     * @param {*} params
     *
     *   // POST 요청 예제.
     *   this.$post("/reqesturl", {"param1":"", "param2":""}, response => {
     *     console.log( response );
     *   }, error => {
     *     console.log( error );
     *   });
     *
     */
    Vue.prototype.$syncPost = async function(url, params, cbSuccess, cbError) {
      //공통 헤더 정보를 포함함.
      let header = {
        browser: this.$store.getters["system/getBrowser"],
        version: this.$store.getters["system/getVersion"],
        os: this.$store.getters["system/getOS"],
        route: this.$route["name"],
        userAgent: navigator.userAgent
      };

      try {
        let response = await http
          .post(
            url,
            {
              header: header,
              data: params
            },
            { withCredentials: true }
          )
          .then();

        this.log_debug("syncPost api:", response);
        if (!this.$Util.isEmpty(response.data)) {
          if (response.data.code === "000000") {
            if (!this.$Util.isNull(cbSuccess)) {
              cbSuccess(response.data);
            }
          } else {
            //오류 가 났을때 기본 처리
            if (!this.$Util.isNull(cbError)) {
              cbError(response);
            } else {
              //콜백이 등록되지 않았을 경우
              if (!this.$Util.isEmpty(response.data.message))
                if (
                  response.config.url.indexOf("reqERSLink") == -1 &&
                  response.config.url.indexOf("reqErsSetCbtYn") == -1
                ) {
                  this.toast(response.data.message);
                }
            }
          }
        } else {
          if (!this.$Util.isNull(cbSuccess)) {
            cbSuccess(response.data);
          }
        }

        return response;
      } catch (error) {
        if (error.toString().indexOf("Network Error") > -1) {
          this.toast(
            "일시적으로 서비스 연결이 지연되고 있습니다.<BR />잠시 후 다시 시도해주세요."
          );
        } else {
          //오류 가 났을때 기본 처리
          if (!this.$Util.isNull(cbError)) {
            cbError(error.response);
          } else {
            //콜백이 등록되지 않았을 경우
            if (!this.$Util.isEmpty(error.response.data.message))
              if (
                error.response.config.url.indexOf("reqERSLink") == -1 &&
                error.response.config.url.indexOf("reqErsSetCbtYn") == -1
              ) {
                this.toast(error.response.data.message);
              }
          }
        }

        return error;
      }
    };

    /**
     * 페이지 이동 공통 함수
     *
     * @param {*} page
     * @param {*} params
     * @param {*} query
     */
    Vue.prototype.$go = async function(page, params, query) {
      this.log_debug(page, params, query);
      let to_url = {};

      to_url.name = page;
      if (!this.$Util.isEmpty(params)) {
        to_url.params = params;
      }

      if (!this.$Util.isEmpty(query)) {
        to_url.query = query;
      }

      try {
        await this.$router.push(to_url);
      } catch (err) {
        throw new Error("program handling something: ${err}).");
      }
    };

    /**
     * 페이지 이동 공통 함수
     * @param {*} page
     * @param {*} params
     * @param {*} query
     */
    Vue.prototype.$replace = function(page, params, query) {
      this.log_debug(page, params, query);
      let to_url = {};

      to_url.name = page;
      if (!this.$Util.isEmpty(params)) {
        to_url.params = params;
      }

      if (!this.$Util.isEmpty(query)) {
        to_url.query = query;
      }

      this.$router.replace(to_url);
    };

    // Vue.prototype.$reload = function( page, params ) {
    //   console.log( page, params );
    //   //router.push(page);
    //   console.log( this );
    //   this.$router.push(page);
    // }

    /*
     *  화면 이동 공통 함수 : 이전화면으로 이동
     */
    Vue.prototype.$goBack = function() {
      this.$router.go(-1);
    };

    /**
     * URL 처리를 위함 새창 오픈 함수
     * @param {*} page
     * @param {*} params
     */
    Vue.prototype.$open = function(url) {
      // if (!this.$Util.isEmpty(params)){
      //   to_url.params = params;
      // }
      // try {
      // alert("params.url : " + url);

      // } catch(e) {
      //   alert(e.toString());
      // }
      window.open(url);
    };

    /**
     * 로컬 여부 반환
     */
    Vue.prototype.isLocal = function() {
      let retVal = false;
      this.log_debug(window.location.host);
      this.log_debug(window.location.protocol);
      this.log_debug(window.location.href);
      this.log_debug(window.location.hostname);

      if (
        window.location.protocol !== "https:" &&
        !window.location.host.startsWith("vars") &&
        !window.location.host.startsWith("testvars")
      ) {
        retVal = true;
      }

      return retVal;
    };

    /**
     * Test 여부 반환
     */
    Vue.prototype.isTest = function() {
      let retVal = false;
      if (
        window.location.protocol === "https:" &&
        window.location.host.startsWith("testvars")
      ) {
        retVal = true;
      }

      return retVal;
    };

    /**
     * 운영 여부 반환
     */
    Vue.prototype.isProd = function() {
      let retVal = false;
      if (
        window.location.protocol === "https:" &&
        window.location.host.startsWith("vars")
      ) {
        retVal = true;
      }

      return retVal;
    };

    /**
     * 대표번호로 전화 연결
     * @param {*} page
     * @param {*} params
     */
    Vue.prototype.$call = function(callNumber) {
      let arsNumber = "";

      if (!this.$Util.isEmpty(callNumber)) {
        arsNumber = callNumber;
      } else {
        arsNumber = process.env.VUE_APP_RESP_NUM;
      }

      //-문자 제거
      arsNumber = arsNumber.replace(/-/g, "");
      this.log_debug(arsNumber);
      window.location.href = "tel://" + arsNumber;
    };

    /*
     *  화면 진입시 화면 route meta값에 의해 화면 UI를 초기화 하는 함수
     */
    Vue.prototype.$setPageUI = function() {
      this.$store.dispatch("manageUI/setPageUI", this.$route);
    };
    /*
     *  공통 메시지 창 함수
     *  함수명 : $alert
     *  파라미터 :
     *     _config : {
     *        type:MSG_ALERT : 메시지창, MSG_COMFIRM: 확인창,   -- 이건 필요 없음.
     *        title: 메시지창 제목, 없으면 "알림" default
     *        contents: 메시지창 내용
     *        btn_type: 버튼타입 BTN_TP_OK: 확인, BTN_TP_OKCANCEL : 확인취소, BTN_TP_YESNO : 예/아니오, BTN_TP_CUSTOM :
     *        buttons: 버튼타입이 CUSTOM일경우 버튼 객체
     *     }
     */
    Vue.prototype.$alert = function(_config) {
      return new Promise((resolve, reject) => {
        try {
          //알림창 id
          const name = `modal-alert-${Math.random()}`;

          if (!this.$Util.isEmpty(_config)) {
            this.log_debug(_config);
            let confObj = {};

            //창 제목 설정
            if (!this.$Util.isEmpty(_config.title)) {
              confObj.title = _config.title;
            }

            //내용 설정
            if (!this.$Util.isEmpty(_config.contents)) {
              confObj.text = _config.contents;
            }

            //내용 정렬 설정
            if (!this.$Util.isEmpty(_config.align)) {
              confObj.align = _config.align;
            }

            //하단 버튼 설정
            if (!this.$Util.isEmpty(_config.btn_type)) {
              switch (_config.btn_type) {
                case this.$CONST.BTN_TP_OKCANCEL:
                  {
                    confObj.buttons = [
                      {
                        title: "취소",
                        class: "btn-default",
                        default: true,
                        handler: (index, compojb) => {
                          resolve(this.$CONST.BTN_KND_CANCEL);
                          compojb.$modal.hide(name);
                        }
                      },
                      {
                        title: "확인",
                        class: "btn-primary",
                        handler: (index, compojb) => {
                          resolve(this.$CONST.BTN_KND_OK);
                          compojb.$modal.hide(name);
                        }
                      }
                    ];
                  }
                  break;
                case this.$CONST.BTN_TP_YESNO:
                  {
                    confObj.buttons = [
                      {
                        title: "예",
                        class: "btn-primary",
                        handler: (index, compojb) => {
                          resolve(this.$CONST.BTN_KND_YES);
                          compojb.$modal.hide(name);
                        }
                      },
                      {
                        title: "아니오",
                        class: "btn-default",
                        default: true,
                        handler: (index, compojb) => {
                          resolve(this.$CONST.BTN_KND_NO);
                          compojb.$modal.hide(name);
                        }
                      }
                    ];
                  }
                  break;
                case this.$CONST.BTN_TP_CUSTOM:
                  {
                    confObj.buttons = _config.buttons;
                    confObj.buttons.forEach(button => {
                      button.handler = function(index, compojb) {
                        resolve(index);
                        compojb.$modal.hide(name);
                      };
                    });
                  }
                  break;
                default:
                  {
                    confObj.buttons = [
                      {
                        title: "확인",
                        class: "btn-primary",
                        handler: (index, compojb) => {
                          resolve(this.$CONST.BTN_KND_OK);
                          compojb.$modal.hide(name);
                        }
                      }
                    ];
                  }
                  break;
              } //end switch
            } else {
              confObj.buttons = [
                {
                  title: "확인",
                  class: "btn-primary",
                  handler: (index, compojb) => {
                    resolve(this.$CONST.BTN_KND_OK);
                    compojb.$modal.hide(name);
                  }
                }
              ];
            }

            this.$modal.show(
              ModalAlertComponent,
              confObj,
              {
                name,
                width: "80%",
                height: "auto",
                styles: { "border-radius": "9px" }
              },
              {
                "before-open": event => {
                  this.log_debug("before-open");
                  this.log_debug(event);
                },
                "before-close": event => {
                  this.log_debug("before-close");
                  this.log_debug(event);
                  resolve(-1);
                }
              }
            );
          } //end if
        } catch (error) {
          reject();
        }
      });
    };

    /**
     * 프로그램데이터를 로드함.
     * @method loadPgmData
     * @param {*}
     * @returns
     *
     */
    Vue.prototype.loadPgmData = function() {
      let pgm_data = null;
      const vueobj = this;

      const isReload = this.$store.getters["system/getReload"];

      if (!isReload) {
        //메뉴 데이터 로드
        this.$post("/api/CO/getPgmList", null, function(res) {
          let pgm_list = new Map();

          if (res.data.total == 0) {
            return;
          }

          pgm_data = res.data.list;
          pgm_data.forEach(function(item) {
            pgm_list.set(item.pgm_id, item);
          });

          //메뉴 데이터를 등록 함.
          vueobj.$store.commit("system/setPgmData", pgm_list);

          let json_pmg_list = Object.fromEntries(pgm_list);
          vueobj.$Util.setStore(vueobj.$CONST.STORE_KEY_PGMDATA, json_pmg_list);

          //초기화 완료여부 체크
          vueobj.$store.commit("system/setInitialized");

          vueobj.log_debug("############### pgm_list ##############");
          vueobj.log_debug(pgm_list);
          vueobj.log_debug("############### pgm_list ##############");
        });
      } else {
        let json_pgm_list = this.$Util.getStore(this.$CONST.STORE_KEY_PGMDATA);
        if (!this.$Util.isEmpty(json_pgm_list)) {
          let pgm_list = new Map(Object.entries(json_pgm_list));

          vueobj.log_debug("############### pgm_list2 ##############");
          vueobj.log_debug(pgm_list);
          vueobj.log_debug("############### pgm_list2 ##############");

          //메뉴 데이터를 등록 함.
          this.$store.commit("system/setPgmData", pgm_list);

          //초기화 완료여부 체크
          this.$store.commit("system/setInitialized");
        } else {
          this.$post("/api/CO/getPgmList", null, function(res) {
            let pgm_list = new Map();

            if (res.data.total == 0) {
              return;
            }

            pgm_data = res.data.list;
            pgm_data.forEach(function(item) {
              pgm_list.set(item.pgm_id, item);
            });

            //메뉴 데이터를 등록 함.
            vueobj.$store.commit("system/setPgmData", pgm_list);

            let json_pmg_list = Object.fromEntries(pgm_list);
            vueobj.$Util.setStore(
              vueobj.$CONST.STORE_KEY_PGMDATA,
              json_pmg_list
            );

            //초기화 완료여부 체크
            vueobj.$store.commit("system/setInitialized");

            vueobj.log_debug("############### pgm_list ##############");
            vueobj.log_debug(pgm_list);
            vueobj.log_debug("############### pgm_list ##############");
          });
        }
      }
    };

    /**
     * 메뉴데이터를 로드함.
     * @method loadMenuData
     * @param {*}
     * @returns
     *
     */
    Vue.prototype.loadMenuData = function() {
      let menu_data = null;
      const vueobj = this;

      const isReload = this.$store.getters["system/getReload"];

      if (!isReload) {
        //메뉴 데이터 로드
        this.$post("/api/CO/getMenuList", null, function(res) {
          let menu_list = [];
          if (res.data.total == 0) {
            return;
          }
          menu_data = res.data.list;
          menu_data.forEach(function(item) {
            if (item.level == 1) {
              //최상위 메뉴 일경우   && item.menu_div_cd === "00" && vueobj.$Util.isEmpty(item.menu_disp_nm:"", high_menu_id)
              menu_list.push(item);
            } else {
              //상위 메뉴가 있는경우 - 2depth 인경우 3depth인경우
              if (item.level === 2) {
                // 2Depth인 경우
                for (let sindex in menu_list) {
                  const fobj = menu_list[sindex];
                  if (fobj.menu_id == item.high_menu_id) {
                    if (!vueobj.$Util.isEmpty(fobj.menu_list)) {
                      fobj.menu_list.push(item);
                    } else {
                      fobj.menu_list = [];
                      fobj.menu_list.push(item);
                    }
                  }
                }
              } else {
                const f_menu_id = item.high_menu_id.substr(0, 2) + "0000"; //최상위 메뉴 ID
                for (let sindex in menu_list) {
                  const fobj = menu_list[sindex];
                  if (fobj.menu_id == f_menu_id) {
                    if (!vueobj.$Util.isEmpty(fobj.menu_list)) {
                      for (let seindex in fobj.menu_list) {
                        let sobj = fobj.menu_list[seindex];
                        if (sobj.menu_id == item.high_menu_id) {
                          if (!vueobj.$Util.isEmpty(sobj.menu_list)) {
                            sobj.menu_list.push(item);
                          } else {
                            sobj.menu_list = [];
                            sobj.menu_list.push(item);
                          }
                        }
                      } //end for
                    }
                  }
                }
              }
            }
          });

          //메뉴 데이터를 등록 함.
          vueobj.$store.commit("system/setMenuData", menu_list);

          vueobj.$Util.setStore(vueobj.$CONST.STORE_KEY_MENUDATA, menu_list);

          vueobj.log_debug("############### menu_list ##############");
          vueobj.log_debug(menu_list);
          vueobj.log_debug("############### menu_list ##############");

          //초기화 완료여부 체크
          vueobj.$store.commit("system/setInitialized");
        });
      } else {
        let menu_list = this.$Util.getStore(this.$CONST.STORE_KEY_MENUDATA);
        if (!this.$Util.isEmpty(menu_list)) {
          //메뉴 데이터를 등록 함.
          this.$store.commit("system/setMenuData", menu_list);

          vueobj.log_debug("############### menu_list2 ##############");
          vueobj.log_debug(menu_list);
          vueobj.log_debug("############### menu_list2 ##############");

          //초기화 완료여부 체크
          this.$store.commit("system/setInitialized");
        } else {
          //메뉴 데이터 로드
          this.$post("/api/CO/getMenuList", null, function(res) {
            let menu_list = [];
            if (res.data.total == 0) {
              return;
            }
            menu_data = res.data.list;
            menu_data.forEach(function(item) {
              if (item.level == 1) {
                //최상위 메뉴 일경우   && item.menu_div_cd === "00" && vueobj.$Util.isEmpty(item.menu_disp_nm:"", high_menu_id)
                menu_list.push(item);
              } else {
                //상위 메뉴가 있는경우 - 2depth 인경우 3depth인경우
                if (item.level === 2) {
                  // 2Depth인 경우
                  for (let sindex in menu_list) {
                    const fobj = menu_list[sindex];
                    if (fobj.menu_id == item.high_menu_id) {
                      if (!vueobj.$Util.isEmpty(fobj.menu_list)) {
                        fobj.menu_list.push(item);
                      } else {
                        fobj.menu_list = [];
                        fobj.menu_list.push(item);
                      }
                    }
                  }
                } else {
                  const f_menu_id = item.high_menu_id.substr(0, 2) + "0000"; //최상위 메뉴 ID
                  for (let sindex in menu_list) {
                    const fobj = menu_list[sindex];
                    if (fobj.menu_id == f_menu_id) {
                      if (!vueobj.$Util.isEmpty(fobj.menu_list)) {
                        for (let seindex in fobj.menu_list) {
                          let sobj = fobj.menu_list[seindex];
                          if (sobj.menu_id == item.high_menu_id) {
                            if (!vueobj.$Util.isEmpty(sobj.menu_list)) {
                              sobj.menu_list.push(item);
                            } else {
                              sobj.menu_list = [];
                              sobj.menu_list.push(item);
                            }
                          }
                        } //end for
                      }
                    }
                  }
                }
              }
            });

            //메뉴 데이터를 등록 함.
            vueobj.$store.commit("system/setMenuData", menu_list);

            vueobj.$Util.setStore(vueobj.$CONST.STORE_KEY_MENUDATA, menu_list);

            vueobj.log_debug("############### menu_list ##############");
            vueobj.log_debug(menu_list);
            vueobj.log_debug("############### menu_list ##############");

            //초기화 완료여부 체크
            vueobj.$store.commit("system/setInitialized");
          });
        }
      }
    };

    /**
     * 최초 진입시 접속 고객정보를 조회함(IVR에서 제공).
     * @method reqConnInfo
     * @param {*}
     * @returns
     *
     */
    Vue.prototype.reqConnInfo = function() {
      const vueobj = this;
      const isReload = this.$store.getters["system/getReload"];
      const connKey = this.$store.getters["customer/getConnKey"];

      vueobj.log_debug("reqConnInfo", isReload);
      vueobj.log_debug("reqConnInfo", connKey);

      //여정관리 데이터
      if (!isReload) {
        let params = { skey: connKey };
        //메뉴 데이터 로드
        this.$post(
          "/api/CU/getConnInfo",
          params,
          res => {
            vueobj.log_debug("고객정보 조회");
            vueobj.log_debug(res);

            if (!vueobj.$Util.isEmpty(res.data)) {
              //고객정보 설정
              let connInfo = {};
              connInfo.conn_req_call_id = res.data.connInfo.conn_req_call_id; //callID
              connInfo.conn_req_ani_no = res.data.connInfo.conn_req_ani_no; //ANI번호
              connInfo.conn_req_dnis_val = res.data.connInfo.conn_req_dnis_val; //DNIS 번호

              connInfo.term_yr_val = res.data.termInfo.term_yr_val; //학기년도 정보
              connInfo.term_smtr_val = res.data.termInfo.term_div_val; //학기 정보

              //영업일 / 영업시간 정보
              connInfo.biz_day_yn = res.data.connInfo.biz_day_yn;
              connInfo.biz_sta_tm = res.data.connInfo.biz_sta_tm;
              connInfo.biz_end_tm = res.data.connInfo.biz_end_tm;

              //콜백 등록 가능여부
              connInfo.clbk_yn = res.data.connInfo.clbk_yn;
              
              connInfo.advc_staf_no = res.data.connInfo.advc_staf_no;             //상담_사원_번호
              connInfo.cust_no = res.data.connInfo.cust_no;                       //고객번호
              connInfo.cust_nm = res.data.connInfo.cust_nm;                       //고객명
              connInfo.cnsl_clss_lgcl_cd = res.data.connInfo.cnsl_clss_lgcl_cd;   //상담유형코드(대)
              connInfo.cnsl_clss_mdcl_cd = res.data.connInfo.cnsl_clss_mdcl_cd;   //상담유형코드(중)
              connInfo.cnsl_clss_smcl_cd = res.data.connInfo.cnsl_clss_smcl_cd;   //상담유형코드(소)
              connInfo.cnsl_cust_div_cd = res.data.connInfo.cnsl_cust_div_cd;     //통화관계자코드
              connInfo.scrg_cd = res.data.connInfo.scrg_cd;                       //학적코드
              connInfo.al_crc_tm_ct = res.data.connInfo.al_crc_tm_ct;             //통화시간
              connInfo.cnsr_empno = res.data.connInfo.cnsr_empno;                 //상담자사번(상담앱 로그인ID)
              connInfo.cnsl_rpsv_tno = res.data.connInfo.cnsl_rpsv_tno;           //고객전화가 인입된 대표번호
              connInfo.cal_div_cd = res.data.connInfo.cal_div_cd;                 //콜구분코드(IN/OUT) - 01, 02, 03 ...


              //현재 사용 월 : 12월일때 채무자 정보 보여주기위함.
              connInfo.use_month = res.data.useMonth;

              //영업시간 설정
              vueobj.$store.commit("system/setBizTime", connInfo);

              vueobj.$store.dispatch("customer/saveConnectInfo", connInfo);

              vueobj.$Util.setStore(vueobj.$CONST.STORE_KEY_CONNINFO, connInfo);

              vueobj.log_debug("############### connInfo ##############");
              vueobj.log_debug(connInfo);
              vueobj.log_debug("############### connInfo ##############");

              //초기화 완료여부 체크
              vueobj.$store.commit("system/setInitialized");
            }
          },
          error => {
            vueobj.log_error(error);
            vueobj.$store.dispatch("customer/saveConnectInfo", []);
            vueobj.$store.commit("system/setInitialized");

            //console.log(error.data.code); //== "900009"
            vueobj.$Util.setStore(vueobj.$CONST.STORE_KEY_CONNINFO, []);
            this.$store.commit("system/setInitApp", true);
            this.$replace("VARS99999");
          }
        );
      } else {
        //reload일 경우
        let connInfo = this.$Util.getStore(this.$CONST.STORE_KEY_CONNINFO);
        if (!this.$Util.isEmpty(connInfo)) {
          //영업시간 설정
          vueobj.$store.commit("system/setBizTime", connInfo);

          //메뉴 데이터를 등록 함.
          this.$store.dispatch("customer/saveConnectInfo", connInfo);

          vueobj.log_debug("############### connInfo2 ##############");
          vueobj.log_debug(connInfo);
          vueobj.log_debug("############### connInfo2 ##############");

          //초기화 완료여부 체크
          this.$store.commit("system/setInitialized");
        } else {
          let params = { skey: connKey };
          this.$post(
            "/api/CU/getConnInfo",
            params,
            res => {
              vueobj.log_debug("고객정보 조회");
              vueobj.log_debug(res);

              if (!vueobj.$Util.isEmpty(res.data)) {
                //고객정보 설정
                let connInfo = {};
                connInfo.conn_req_call_id = res.data.connInfo.conn_req_call_id; //callID
                connInfo.conn_req_ani_no = res.data.connInfo.conn_req_ani_no; //ANI번호
                connInfo.conn_req_dnis_val =
                  res.data.connInfo.conn_req_dnis_val; //DNIS 번호

                connInfo.term_yr_val = res.data.termInfo.term_yr_val; //학기년도 정보
                connInfo.term_smtr_val = res.data.termInfo.term_div_val; //학기 정보

                //영업일 / 영업시간 정보
                connInfo.biz_day_yn = res.data.connInfo.biz_day_yn;
                connInfo.biz_sta_tm = res.data.connInfo.biz_sta_tm;
                connInfo.biz_end_tm = res.data.connInfo.biz_end_tm;

                //콜백 등록 가능여부
                connInfo.clbk_yn = res.data.connInfo.clbk_yn;

                connInfo.advc_staf_no = res.data.connInfo.advc_staf_no;             //상담_사원_번호
                connInfo.cust_no = res.data.connInfo.cust_no;                       //고객번호
                connInfo.cust_nm = res.data.connInfo.cust_nm;                       //고객명
                connInfo.cnsl_clss_lgcl_cd = res.data.connInfo.cnsl_clss_lgcl_cd;   //상담유형코드(대)
                connInfo.cnsl_clss_mdcl_cd = res.data.connInfo.cnsl_clss_mdcl_cd;   //상담유형코드(중)
                connInfo.cnsl_clss_smcl_cd = res.data.connInfo.cnsl_clss_smcl_cd;   //상담유형코드(소)
                connInfo.cnsl_cust_div_cd = res.data.connInfo.cnsl_cust_div_cd;     //통화관계자코드
                connInfo.scrg_cd = res.data.connInfo.scrg_cd;                       //학적코드
                connInfo.al_crc_tm_ct = res.data.connInfo.al_crc_tm_ct;             //통화시간
                connInfo.cnsr_empno = res.data.connInfo.cnsr_empno;                 //상담자사번(상담앱 로그인ID)
                connInfo.cnsl_rpsv_tno = res.data.connInfo.cnsl_rpsv_tno;           //고객전화가 인입된 대표번호
                connInfo.cal_div_cd = res.data.connInfo.cal_div_cd;                 //콜구분코드(IN/OUT) - 01, 02, 03 ...

                //현재 사용 월 : 12월일때 채무자 정보 보여주기위함.
                connInfo.use_month = res.data.useMonth;

                //영업시간 설정
                vueobj.$store.commit("system/setBizTime", connInfo);

                vueobj.$store.dispatch("customer/saveConnectInfo", connInfo);

                vueobj.$Util.setStore(
                  vueobj.$CONST.STORE_KEY_CONNINFO,
                  connInfo
                );

                vueobj.log_debug("############### connInfo ##############");
                vueobj.log_debug(connInfo);
                vueobj.log_debug("############### connInfo ##############");

                //초기화 완료여부 체크
                vueobj.$store.commit("system/setInitialized");
              }
            },
            error => {
              vueobj.log_error(error);
              vueobj.$store.dispatch("customer/saveConnectInfo", []);
              vueobj.$store.commit("system/setInitialized");

              //console.log(error.data.code); //== "900009"
              vueobj.$Util.setStore(vueobj.$CONST.STORE_KEY_CONNINFO, []);
              this.$store.commit("system/setInitApp", true);
              this.$replace("VARS99999");
            }
          );
        }
      }
    };

    /**
     * 전화번호로 고객정보를 조회함(기간계 조회 : 전호번호로 조회).
     * @method reqCustInfo
     * @param {*}
     * @returns
     *
     */
    Vue.prototype.reqCustInfo = function() {
      const vueobj = this;
      let connInfo = this.$store.getters["customer/getConnectInfo"];

      if (connInfo == undefined || connInfo == null) {
        return false;
      }

      //여정관리 데이터
      let params = { conn_req_ani_no: connInfo.conn_req_ani_no };
      //메뉴 데이터 로드
      this.$post("/api/CU/getCustInfo", params, function(res) {
        vueobj.log_debug("고객정보 조회");
        vueobj.log_debug(res);
        if (!vueobj.$Util.isEmpty(res.data)) {
          //고객정보 설정
          connInfo.custYn = res.data.custYn; //고객 확인 여부
          connInfo.custNo = res.data.custNo; //고객번호
          connInfo.custNm = res.data.custName; //고객명
          connInfo.brth = res.data.brth; //생년월일
          connInfo.age = res.data.age; //나이
          connInfo.qstMttYn = res.data.qstMttYn; //강성고객여부
          connInfo.tddDupCallYn = res.data.tddDupCallYn; //당일 중복통화여부
          connInfo.finlCallCnsrCti = res.data.finlCallCnsrCti; //최종 통화한 상담사 CTI ID
          connInfo.dbtrRprObjtYn = res.data.dbtrRprObjtYn; //채무자신고대상여부
          connInfo.CustomerSurveyYn = res.data.CustomerSurveyYn; //고객만족도 조사 여부	CustomerSurveyYn

          vueobj.$store.dispatch("customer/saveConnectInfo", connInfo);

          vueobj.$Util.setStore(vueobj.$CONST.STORE_KEY_CONNINFO, connInfo);

          vueobj.log_debug("############### connInfo ##############");
          vueobj.log_debug(connInfo);
          vueobj.log_debug("############### connInfo ##############");
        }
      });
    };

    /**
     * 인증 번호 SMS 발송 요청
     * @method reqSMSAuthNum
     * @param {*}
     * @returns
     *
     */
    Vue.prototype.reqSMSAuthNum = function() {
      //여정관리 데이터
      let params = {};
      let vueobj = this;
      params.conn_req_call_id = this.$store.getters["customer/getConnInfo"](
        "conn_req_call_id"
      );

      this.$post("/api/AZ/reqSMSAuthNum", params, function(res) {
        vueobj.log_debug(res);
      });
    };

    /**
     * 인증 SMS 확인
     * @method confirmSMSAuth
     * @param {*}
     * @returns
     *
     */
    Vue.prototype.confirmSMSAuth = function(cert_cnfm_no) {
      const vueobj = this;

      let params = {};
      params.conn_req_call_id = this.$store.getters["customer/getConnInfo"](
        "conn_req_call_id"
      );
      params.cert_cnfm_no = cert_cnfm_no;

      this.$post("/api/AZ/confirmSMSAuth", params, function(res) {
        vueobj.log_debug(res);

        if (!vueobj.$Util.isEmpty(res.data)) {
          let userInfo = {};
          userInfo.custNo = res.data.userInfo.custNo; //고객번호
          userInfo.custNm = res.data.userInfo.custNm; //고객명

          vueobj.log_debug(userInfo);

          vueobj.$store.dispatch("customer/saveLogin", userInfo);
        }
      });
    };

    /**
     * 인증 IVR 비밀번호 인증
     * @method confirmIVRAuth
     * @param {*}
     * @returns
     *
     */
    Vue.prototype.confirmIVRAuth = function(authz_no) {
      const vueobj = this;

      let params = {};
      params.conn_req_call_id = this.$store.getters["customer/getConnInfo"](
        "conn_req_call_id"
      );
      params.authz_no = authz_no;
      params.brth = this.$store.getters["customer/getConnInfo"]("brth"); //생년월일
      params.tno = this.$store.getters["customer/getConnInfo"](
        "conn_req_ani_no"
      );

      this.$post("/api/AZ/confirmIVRAuth", params, function(res) {
        vueobj.log_debug(res);

        if (!vueobj.$Util.isEmpty(res.data)) {
          let userInfo = {};
          userInfo.custNo = res.data.userInfo.custNo; //고객번호
          userInfo.custNm = res.data.userInfo.custNm; //고객명

          vueobj.log_debug(userInfo);

          vueobj.$store.dispatch("customer/saveLogin", userInfo);
        }
      });
    };

    /**
     * 인증 해제
     * @method expireAuth
     * @param {*}
     * @returns
     *
     */
    Vue.prototype.expireAuth = function() {
      //const vueobj = this;
      this.$store.dispatch("customer/saveLogout");

      //세션에 저장된 로그인 정보를 제거
      this.$Util.removeStore(this.$CONST.STORE_KEY_USER);
    };

    /**
     * 화면 종료
     * @method closeService
     * @param {*}
     * @returns
     *
     */
    Vue.prototype.closeService = function(isReplace, params) {
      let keyVal = this.$Util.getStore(this.$CONST.STORE_KEY_CONNKEY);
      if (this.$Util.isEmpty(keyVal)) {
        //이미 커넥션키가 삭제된 경우 바로 이용종료 화면으로 이동시킴.
        this.$replace("VARS00300");
        return false;
      }

      let rparams = {};
      rparams.conn_req_call_id = this.$store.getters["customer/getConnInfo"](
        "conn_req_call_id"
      );

      this.$syncPost("/api/AZ/reqExpireAuth", rparams, res => {
        if (res.code === "000000") {
          this.$store.dispatch("customer/saveLogout"); //이거 문제네.....

          //세션에 저장된 로그인 정보를 제거
          this.$Util.removeStore(this.$CONST.STORE_KEY_CONNKEY);
          this.$Util.removeStore(this.$CONST.STORE_KEY_CONNINFO); //얘는 삭제할지 말지 확인
          this.$Util.removeStore(this.$CONST.STORE_KEY_USER);

          //이용종료 화면으로 이동시킴
          if (isReplace) {
            this.$replace("VARS00300", params);
          } else {
            this.$go("VARS00300", params);
          }
        }
      });
    };

    /**
     * 서류제출 화면 종료
     * @method closeService
     * @param {*}
     * @returns
     *
    */
    Vue.prototype.documentCloseService = function() {
        this.$replace("VARS20011");
    };

    /**
     * 영업시간 체크 여부
     * @method checkBizTime
     * @param {*}
     * @returns
     *
     */
    Vue.prototype.checkBizTime = function() {
      //const vueobj = this;
      let retVal = false;

      //영업시간 체크
      const bizDayYn = this.$store.getters["system/getBizDay"];
      const bizStartTm = this.$store.getters["system/getBizStaTm"];
      const bizEndTm = this.$store.getters["system/getBizEndTm"];

      if (bizDayYn === "Y") {
        const curDate = new Date();
        const startHour = parseInt(bizStartTm.substr(0, 2));
        const startMinute = parseInt(bizStartTm.substr(2, 2));
        const startSecond = parseInt(bizStartTm.substr(4, 2));
        const startDate = new Date(
          curDate.getFullYear(),
          curDate.getMonth(),
          curDate.getDate(),
          startHour,
          startMinute,
          startSecond
        );

        const endHour = parseInt(bizEndTm.substr(0, 2));
        const endMinute = parseInt(bizEndTm.substr(2, 2));
        const endSecond = parseInt(bizEndTm.substr(4, 2));
        const endDate = new Date(
          curDate.getFullYear(),
          curDate.getMonth(),
          curDate.getDate(),
          endHour,
          endMinute,
          endSecond
        );

        if (
          curDate.getTime() >= startDate.getTime() &&
          curDate.getTime() < endDate.getTime()
        ) {
          retVal = true;
        }
      }
      return retVal;
    };

    /**
     * 화면 진입시 여정관리 서비스 호출
     * @method reqERSLink
     * @param {*}
     * @returns
     *
     */
    Vue.prototype.reqERSLink = function(divCode) {
      const vueobj = this;
      let svcCd = vueobj.$route.name;

      // 챗봇 연결이면 서비스 코드를 바꾸어 준다.
      if (divCode === "CBT") {
        svcCd = svcCd + "B";
      }

      if (!svcCd) return; //서비스코드가 설정되지 않았으면 리턴
      if (!vueobj.$store.getters["system/getInitialized"]) return;

      let lastSvcCd = vueobj.$store.getters["system/getLastErsLink"];
      if (lastSvcCd == svcCd) return;

      //여정관리 데이터
      let params = {};
      params.callid = vueobj.$store.getters["customer/getConnInfo"](
        "conn_req_call_id"
      );

      if (!params.callid) return;

      params.dnis = vueobj.$store.getters["customer/getConnInfo"](
        "conn_req_dnis_val"
      );
      params.ani = vueobj.$store.getters["customer/getConnInfo"](
        "conn_req_ani_no"
      );
      params.serviceCode = svcCd;
      // 초기 진입 시 reqErsSetCbtYn 함수 및 해당함수에서 에러일 경우 해당 값을 false로 셋팅한다.
      params.isAliveERS = vueobj.$store.getters["system/getIsAliveERS"];

      vueobj.$post("/api/IE/reqERSLink", params, null, function(error) {
        // 에러일 경우 ERS 시스템 서버다운 여부에 셋팅.
        vueobj.$store.commit("system/setIsAliveERS", false);
        vueobj.toast(error.data.message);
      });

      //마지막 연동값을 저장한다.
      vueobj.$store.commit("system/setLastErsLink", svcCd);
    };

    /**
     * IVR과 연계
     * @method reqIVR
     * @param {*}
     * @returns
     *
     */
    Vue.prototype.reqIVR = function(
      divCd,
      sklCd,
      cbSuccess,
      cbError,
      authInfo
    ) {
      const vueobj = this;

      if (!this.$store.getters["system/getInitialized"]) return;
      
      //여정관리 데이터
      let params = {};
      vueobj.log_debug("--------------------");
      vueobj.log_debug("reqIVR:", params);

      params.conn_req_call_id = this.$store.getters["customer/getConnInfo"](
        "conn_req_call_id"
      ); //접속_요청_CALL_ID
      params.conn_req_ani_no = this.$store.getters["customer/getConnInfo"](
        "conn_req_ani_no"
      ); //접속_요청_ANI_번호
      params.conn_req_dnis_val = this.$store.getters["customer/getConnInfo"](
        "conn_req_dnis_val"
      ); //접속_요청_DNIS_값
      params.conn_req_div_val = divCd; //연계_요청_구분_값 DIS : 통화종료, CON : 상담사연결, VARS : VARS00100화면에서 눌려진 버튼, IVR : 음성 ARS 버튼
      params.skl_cd = sklCd; //스킬_코드

      if (!this.$Util.isEmpty(authInfo)) {
        /*고객번호로 인증여부 판단.*/
        params.conn_cust_no = authInfo.custNo; //접속_고객_번호

        //let selfConfirmInfo = this.$store.getters["customer/getSelfConfirmInfo"]; // 본인확인
        let connInfo = this.$store.getters["customer/getConnectInfo"]; // 인입시 고객 정보
        let isTryAuth = this.$store.getters["customer/isTryAuth"]; //인증시도여부

        // 고객번호가 없는 경우 본인확인 여부를 판단(비고객 or 본인확인 실패를 구분, 02: 비고객, 03: 본인확인 실패)
        if (authInfo.custNo == null || authInfo.custNo == "") {
            if (connInfo.custNo) {    // 고객
              //params.cust_cert_div_cd = '03';
              params.cust_cert_div_cd = isTryAuth ? '02' : '03';    // 인증실패면 02, 본인확인 실패면 03

            } else {
              // 비고객 이면서 비용자이거나 본인확인 실패시에는 02
              params.cust_cert_div_cd = '02';
            }

            //params.cust_cert_div_cd = selfConfirmInfo == null ? '02' : '03';

        } else {
          params.cust_cert_div_cd = '01';
        }
        //selfConfirmInfo = this.$store.getters["customer/getSelfConfirmInfo"]; // 본인확인
        //params.cust_cert_div_cd = authInfo.custNo ? "01" : "02"; //고객_인증_구분_코드 01 : 인증 02 : 비인증
      } else {
        /*고객번호로 인증여부 판단.*/
        params.conn_cust_no = this.$store.getters["customer/getUserInfo"](
          "custNo"
        ); //접속_고객_번호
        params.cust_cert_div_cd = this.$store.getters["customer/getUserInfo"](
          "custNo"
        )
          ? "01"
          : "02"; //고객_인증_구분_코드 01 : 인증 02 : 비인증
      }

      params.cust_stsfatn_srvy_yn = this.$store.getters["customer/getConnInfo"](
        "CustomerSurveyYn"
      ); //고객_만족도_조사_여부 Y : 조사대상, N : 비대상
      if (this.$Util.isEmpty(params.cust_stsfatn_srvy_yn)) {
        params.cust_stsfatn_srvy_yn = "N";
      }

      vueobj.log_debug("reqIVR ------ 상담사연결, 챗봇 연결 시에만 추가");
      if (divCd == "CON" || divCd == "CBT") {
        let conDivCd = divCd == "CON" ? "A" : "B";

        let svcCd = this.$route.name + conDivCd;
        if (!this.$Util.isEmpty(authInfo)) {
          svcCd = authInfo.svcCode + conDivCd;
        } else {
          svcCd = this.$route.name + conDivCd;
        }
        params.callid = params.conn_req_call_id;
        params.dnis = params.conn_req_dnis_val;
        params.ani = params.conn_req_ani_no;
        params.serviceCode = svcCd;
        // 초기 진입 시 reqErsSetCbtYn 함수 및 reqERSLink함수에서 에러일 경우 해당 값을 false로 셋팅한다.
        params.isAliveERS = vueobj.$store.getters["system/getIsAliveERS"];
      }

      vueobj.log_debug(params);

      //IVR 연계 요청
      this.$syncPost("/api/IV/reqIVR", params, function(res) {
        if (res.code === "000000") {
          if (!vueobj.$Util.isEmpty(cbSuccess)) {
            cbSuccess(res);
          }
        } else {
          if (!vueobj.$Util.isEmpty(cbError)) {
            cbError();
          }
        }
      });
    };

    /**
     * ERS 챗봇 노출 여부 설정값 조회
     * @method reqIsERSSetCbt
     * @param {*}
     * @returns
     *
     */
    Vue.prototype.reqErsSetCbtYn = function() {
      const vueobj = this;
      let params = {};
      let ersSetCbtYn;

      params.dnis = vueobj.$store.getters["customer/getConnInfo"](
        "conn_req_dnis_val"
      ); //접속_요청_DNIS_값

      this.$post(
        "/api/IE/reqErsSetCbtYn",
        params,
        function(res) {
          // ERS에서 챗봇 노출 설정값 받아와서 store/system의 ersSetCbtYn 변수에 commit
          ersSetCbtYn = res.data.ersSetCbtYn;
          //ersSetCbtYn = "N";
          //console.log('ERS 챗봇 노출 여부 : ', ersSetCbtYn);
          vueobj.$store.commit("system/setErsSetCbtYn", ersSetCbtYn);
        },
        function() {
          // 에러일 경우 ERS 시스템 서버다운 여부에 셋팅.
          vueobj.$store.commit("system/setIsAliveERS", false);
        }
      );
    };

    /**
     * 챗봇 연계 요청 함수
     * @method reqChatBot
     * @param {*}
     * @returns
     *
     */
    Vue.prototype.reqChatBot = function(cbSuccess, cbError) {
      const vueobj = this;
      vueobj.log_debug("챗봇요청 시작--------------");
      //프로그램 정보
      const objProgram = this.getProgramData();
      if (objProgram) {
        //챗봇 멘트 요청
        let params = {};

        // cbt_scnri_id //시나리오 ID
        // cbt_nd_id    //노드 ID
        // cbt_qst_id   //질문 ID 이건 사용하지 않음.

        if (!this.$Util.isEmpty(objProgram.cbt_scnri_id)) {
          params.scenario_id = objProgram.cbt_scnri_id;
          // 1. "scenario_id" : "IPVDcnQBX9J3xwoVYHZP"
          // 2. "card_id" : "1", "1_1", "1_2", "1_3", "1_4"

          if (!this.$Util.isEmpty(objProgram.cbt_nd_id)) {
            const arrCards = objProgram.cbt_nd_id.split(",");
            if (arrCards.length == 1) {
              params.card_id = arrCards[0];
            }
          }

          /* 개발 테스트용 코드 */
          // if (params.scenario_id == "jxay8nUBA31xODSHiGlW") {
          //   params.scenario_id = "ymtj9HUByB7OBBEJ7THO";
          // } else if (params.scenario_id == "YUmNk3UBA31xODSHaLWu") {
          //   //국가장학금 > 자주하는 질문 > 국가장학금 1유형
          //   params.scenario_id = "MfV8dXQBX9J3xwoVBagr";
          // } else if (params.scenario_id == "pkmMk3UBA31xODSHeaiL") {
          //   //국가장학금 > 자주하는 질문 > 국가장학금 2유형
          //   params.scenario_id = "ZvV8dXQBX9J3xwoVfKgn";
          // } else if (params.scenario_id == "uEmOk3UBA31xODSHOcD9") {
          //   //국가장학금 > 자주하는 질문 > 다자녀 국가장학금
          //   params.scenario_id = "kvV8dXQBX9J3xwoV";
          // } else if (params.scenario_id == "NEqTk3UBA31xODSH4BDV") {
          //   //국가장학금 > 자주하는 질문 > 다자녀 국가장학금
          //   params.scenario_id = "w_V9dXQBX9J3xwoVTqhP";
          // }
          /* 개발 테스트용 코드 끝 */
          vueobj.log_debug(params);

          // let reqUrl = process.env.VUE_APP_CHATBOT;
          // if (!this.$Util.isEmpty(params.card_id)) {
          //   reqUrl = reqUrl + "/card";
          // }

          // console.log(reqUrl);
          // this.$post(reqUrl, params, function(res) {
          //   if (res.code === "000000") {
          //     if (!vueobj.$Util.isEmpty(cbSuccess)) {
          //       cbSuccess(res);
          //     }
          //   } else {
          //     if (!vueobj.$Util.isEmpty(cbError)) {
          //       cbSuccess(res);
          //     }
          //   }
          // });

          //BackEnd 호출
          this.$post("/api/IC/reqCBMent", params, function(res) {
            vueobj.log_debug("----챗봇요청 결과----");
            vueobj.log_debug(res);
            vueobj.log_debug("----챗봇요청 결과 끝----");
            if (res.code === "000000") {
              if (!vueobj.$Util.isEmpty(cbSuccess)) {
                cbSuccess(res.data);
              }
            } else {
              if (!vueobj.$Util.isEmpty(cbError)) {
                cbError(res);
              }
            }
          });
        } else {
          // 정의된 시나리오 코드가 없을 경우 undefined 로 넘겨준다.
          if (!vueobj.$Util.isEmpty(cbSuccess)) {
            cbSuccess();
          }
        }
      }
    };

    /**
     * 챗봇 서비스가 가능한지 체크 함수
     * @method reqOpenCbtYn
     * @param {*}
     * @returns
     */
    Vue.prototype.reqOpenCbtYn = function() {
      const vueobj = this;
      let openCbtYn;
      let openEpYn;
      this.$post("/api/IC/reqOpenCbtYn", null, function(res) {
        // 챗봇서비스 가능 결과 여부를 받아와서 store/system의 openCbtYn 변수에 commit
        openCbtYn = res.data.appYn; // 앱 챗봇 오픈 여부(app)
        openEpYn = res.data.epYn; // 학습특별지원금 챗봇 오픈 여부(web)
        vueobj.$store.commit("system/setOpenCbtYn", openCbtYn);
        vueobj.$store.commit("system/setOpenEpYn", openEpYn);
        //vueobj.$store.commit("system/setOpenCbtYn", "Y");
        //vueobj.$store.commit("system/setOpenEpYn", "N");
      });
    };

    /**
     * 챗봇데이터 체크 함수
     * @method validChatBot
     * @param {*}
     * @returns boolean
     *
     */
    Vue.prototype.validChatBotMent = function(data) {
      let retVal = false;
      if (!this.$Util.isEmpty(data) && !this.$Util.isEmpty(data.detail)) {
        retVal = true;
      }
      return retVal;
    };

    /**
     * 자주찾는 질문 내용을 파싱
     * @method parseQNA
     * @param {*}
     * @returns
     *
     */
    Vue.prototype.parseQNA = function(data) {
      this.log_debug(data);
      let qnaList = [];

      const objProgram = this.getProgramData();

      let qnaCard = null;
      data.cards.forEach(card => {
        if (card.id === objProgram.cbt_qst_id) {
          //질문id에 해당하면
          qnaCard = card;
        }
      });

      //질문내용 추출
      if (!this.$Util.isEmpty(qnaCard)) {
        qnaCard.action.forEach(action => {
          if (action.action_type === "card") {
            qnaList.push({
              query: action.detail.text,
              link: action.detail.link_url
            });
          }
        });
      }

      //답변내용 추출
      if (!this.$Util.isEmpty(qnaList)) {
        qnaList.forEach(query => {
          data.cards.forEach(card => {
            if (card.id === query.link) {
              query.answer = card.detail.text;
              return;
            }
          });
        });
      }

      return qnaList;
    };

    /**
     * 화면의 공지사항 요청
     * @method reqNotice
     * @param {*}
     * @returns
     *
     */
    Vue.prototype.reqNotice = function(cbSuccess, cbError) {
      const vueobj = this;

      let params = {};

      const objProgram = this.getProgramData();
      if (objProgram) {
        params.pgm_id = objProgram.pgm_id;
        vueobj.log_debug(objProgram);
        vueobj.log_debug(params);

        //공지사항 연계 요청
        this.$syncPost("/api/CO/getNotice", params, function(res) {
          if (res.code === "000000") {
            if (!vueobj.$Util.isEmpty(cbSuccess)) {
              cbSuccess(res.data);
            } else {
              if (!vueobj.$Util.isEmpty(res.data)) {
                vueobj.$store.commit("system/setNotice", res.data.ntce_cont);
              }
            }
          } else {
            vueobj.log_debug("에러로 떨어지나?");
            if (!vueobj.$Util.isEmpty(cbError)) {
              cbError();
            } else {
              vueobj.$store.commit("system/setNotice", null);
            }
          }
        });
      }
    };

    /**
     * 해당 화면에 대한 정보를 조회
     * @method getProgramData
     * @param {*}
     * @returns
     *
     */
    Vue.prototype.getProgramData = function() {
      let objProgram = null;
      const pgmList = this.$store.getters["system/getPgmData"];
      if (pgmList) {
        objProgram = pgmList.get(this.$route.name);
      }
      return objProgram;
    };

    /**
     * 문자열을 AES256 암호화 한다.
     * @method $encryptAES
     * @param {*} plainTxt 암호화할 평문 문자열
     * @returns AES256으로 암호화된 문자열
     *
     */
    Vue.prototype.$encryptAES = function(plainTxt) {
      let key = this.CryptoJS.enc.Utf8.parse(process.env.VUE_APP_SECRYPT);
      let iv = this.CryptoJS.enc.Utf8.parse(
        process.env.VUE_APP_SECRYPT.substr(0, 16)
      );

      return this.CryptoJS.AES.encrypt(plainTxt, key, { iv: iv }).toString();
    };

    /**
     * AES256으로 암호화된 문자열을 복호화 한다.
     * @method $decryptAES
     * @param {*} encryptedTxt AES256으로 암호화된 문자열
     * @returns 복호화된 평문 문자열
     */
    Vue.prototype.$decryptAES = function(encryptedTxt) {
      let key = this.CryptoJS.enc.Utf8.parse(process.env.VUE_APP_SECRYPT);
      let iv = this.CryptoJS.enc.Hex.parse(
        process.env.VUE_APP_SECRYPT.substr(0, 16)
      );

      return this.CryptoJS.AES.decrypt(encryptedTxt, key, {
        iv: iv
      }).toString();
    };

    /**
     * 토스트 메시지 표시
     * @method toast
     * @param {*} msg 토스트 표시될 메시지
     * @returns 복호화된 평문 문자열
     */
    Vue.prototype.toast = function(msg) {
      let element = "";
      element += "<div class='toast-msg' id='toastMsg' style='display:none'>";
      element += msg;
      element += "</div>";
      $("#app").append(element);
      $(".toast-msg").fadeIn();

      setTimeout(function() {
        $(".toast-msg").fadeOut(500);
        $(".toast-msg").remove();
      }, 2000);
    };
  } // End install
};
